import {
	CLEAR_CUSTOMER_ATTR_GLOBAL,
	EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN,
	EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_CUSTOMER_ATTR_GLOBAL_FILTERS,
	SET_CUSTOMER_ATTR_GLOBAL_FILTERS_SUCCESS,
	SET_CUSTOMER_ATTR_INDIVIDUAL,
	SET_CUSTOMER_ATTR_INDIVIDUAL_SUCCESS
} from 'constants/ActionsTypes'

export interface valueState {
	customerAttrList: any
	customerAttrIndividualAccept: any
	customerAttrGlobalAssignConfirmed: any
	customerAttrEdit: any
	customerAttrGlobalAssigned: any
	customerAttrPagination: any
}

const initialState = {
	customerAttrList: null,
	customerAttrIndividualAccept: null,
	customerAttrGlobalAssignConfirmed: null,
	customerAttrEdit: null,
	customerAttrGlobalAssigned: null,
	customerAttrPagination: null
}

function rootReducer(state: valueState = initialState, action: any) {
	switch (action.type) {
		case SET_CUSTOMER_ATTR_GLOBAL_FILTERS:
			return { ...state, customerAttrList: null }
		case SET_CUSTOMER_ATTR_GLOBAL_FILTERS_SUCCESS:
			return { ...state, customerAttrList: action.payload }
		case SET_CUSTOMER_ATTR_INDIVIDUAL:
			return { ...state, customerAttrIndividualAccept: null }
		case SET_CUSTOMER_ATTR_INDIVIDUAL_SUCCESS:
			return { ...state, customerAttrIndividualAccept: action.payload }
		case SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM:
			return { ...state, customerAttrGlobalAssignConfirmed: null }
		case SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS:
			return { ...state, customerAttrGlobalAssignConfirmed: action.payload }
		case EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN:
			return { ...state, customerAttrEdit: null }
		case EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN_SUCCESS:
			return { ...state, customerAttrEdit: action.payload }
		case SET_CUSTOMER_ATTR_GLOBAL_ASSIGN:
			return { ...state, customerAttrGlobalAssigned: null }
		case SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_SUCCESS:
			return { ...state, customerAttrGlobalAssigned: action.payload }

		case SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION:
			return { ...state, customerAttrPagination: null }
		case SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS:
			return { ...state, customerAttrPagination: action.payload }
		case CLEAR_CUSTOMER_ATTR_GLOBAL:
			return { ...state, customerAttrPagination: null, customerAttrList: null }
		default:
			return state
	}
}

export default rootReducer
